// extracted by mini-css-extract-plugin
export default {"row":"resume_row__OulCa","main":"resume_main__L73WT","aside":"resume_aside__leowA","contact":"resume_contact__nkVK9"};